<template>
  <div class="ProgressCircle__wrapper" :data-progress="progress">
    <div class="ProgressCircle__circle">
      <div class="ProgressCircle__slice full">
        <div class="ProgressCircle__fill"></div>
      </div>
      <div class="ProgressCircle__slice">
        <div class="ProgressCircle__fill"></div>
        <div class="ProgressCircle__fill ProgressCircle__bar"></div>
      </div>
    </div>
    <div class="ProgressCircle__overlay">
      {{ progress }}%
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProgressCircle',
    props: {
      progress: {
        required: true
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// progress-circle.vue?0fbf0a40